import { useQuery } from '@tanstack/react-query'
import { TriangleAlert } from 'lucide-react'
import { useState } from 'react'
import { GemaaktDoor } from '@/components/layout/GemaaktDoor'
import { Skeleton } from '@/components/ui/Skeleton'
import { http } from '@/lib/api'

type Omgeving = {
  status: string
  product: 'beheer' | 'upload'
  authMode: 'entra' | 'local'
  database: string
}

function useOmgeving() {
  return useQuery({
    queryKey: ['omgeving'],
    queryFn: () => http.get<Omgeving>('/api/health'),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  })
}

export function LoginPage({ fout }: { fout?: string }) {
  const omgeving = useOmgeving()
  const [email, setEmail] = useState('')

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 px-4 py-16">
      <div className="w-full max-w-sm rounded-card bg-surface p-8 shadow-card">
        <p className="text-sm font-semibold tracking-[-0.01em] text-ink">Inzetplanning</p>
        <p className="text-[11px] text-ink-faint">NT2 Windesheim</p>

        <h1 className="mt-6 text-[22px] font-semibold tracking-[-0.02em] text-ink">Inloggen</h1>
        <p className="mt-1 text-sm text-ink-faint">
          {omgeving.data?.authMode === 'local'
            ? 'Deze omgeving draait zonder Entra. Vul het e-mailadres in van een gebruiker die al bestaat.'
            : 'Je logt in met je Windesheim-account. Daarna kom je op het teamoverzicht van het lopende semester.'}
        </p>

        {fout === 'geen_toegang' ? (
          <p className="mt-4 flex items-start gap-2 rounded-lg bg-status-overbezet/10 px-3 py-2.5 text-sm text-status-overbezet">
            <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={1.85} />
            Dit account heeft geen toegang tot de inzetplanning. Vraag de beheerder om je toe te
            voegen.
          </p>
        ) : null}

        {omgeving.isLoading ? (
          <Skeleton className="mt-6 h-10 w-full" />
        ) : omgeving.data?.authMode === 'local' ? (
          <form action="/auth/local/login" method="get" className="mt-6 space-y-3">
            <input
              type="email"
              name="email"
              required
              autoComplete="username"
              placeholder="naam@windesheim.nl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field w-full"
            />
            <button type="submit" className="btn-primary w-full">
              Lokaal inloggen
            </button>
          </form>
        ) : (
          <a href="/auth/entra/login" className="btn-primary mt-6 w-full">
            Inloggen met Windesheim
          </a>
        )}
      </div>

      <GemaaktDoor />
    </div>
  )
}
